<template>
    <div
        class="live-score-widget"
        :class="[{ 'live-score-widget--flex-end' : isFlexEndAlignment }, `server-${liveData.serve || 0}`]"
    >
        <div
            class="live-score-widget__periods-container"
        >
            <div
                v-if="showPeriodNames"
                class="live-score-widget__periods"
            >
                <div
                    v-for="period in periodNames"
                    :key="period"
                    class="live-score-widget__period e2e-live-score-number"
                >
                    {{ $t(period) }}
                </div>
            </div>
        </div>
        <div class="live-score-widget__score">
            <div
                v-for="(period, i) in liveData.score"
                :key="i"
                class="live-score-widget__score-column"
            >
                <div
                    class="live-score-widget__score-number e2e-live-score-number"
                    :class="[getPeriodWonClass(period, 0, i), getTennisPointsClass(i)]"
                >
                    {{ period[0] }}
                </div>
                <div
                    class="live-score-widget__score-number e2e-live-score-number"
                    :class="[getPeriodWonClass(period, 1, i), getTennisPointsClass(i)]"
                >
                    {{ period[1] }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        respondToBelow,
        ScreenWidth,
    } from '@superbet-group/web.lib.vue-utilities';

    import { SportId } from '@core/constants';

    import { getPeriodNames } from './constants';
    import { getLiveData } from './helpers';

    export default {
        props: {
            sportId: {
                type: Number,
                required: true,
            },
            rawLiveData: {
                type: Object,
                required: true,
            },
            useCompactLiveData: {
                type: Boolean,
                required: false,
            },
            isMatchFinished: {
                type: Boolean,
                default: false,
            },
            isFlexEndAlignment: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            liveData() {
                return getLiveData(this.sportId, this.rawLiveData, this.useCompactView, this.isMatchFinished);
            },
            periodNames() {
                return getPeriodNames(this.sportId, this.liveData.score.length, this.useCompactView);
            },
            useCompactView() {
                if (this.useCompactLiveData) {
                    return true;
                }
                return respondToBelow(ScreenWidth.tSm);
            },
            showPeriodNames() {
                const sportsWithPeriodNamesInCompactView = [
                    SportId.Tennis,
                    SportId.Football,
                    SportId.Volleyball,
                    SportId.TableTennis,
                    SportId.BeachVolleyball,
                    SportId.Badminton,
                ];
                return (sportsWithPeriodNamesInCompactView.includes(this.sportId) || !this.useCompactView)
                    && !this.isMatchFinished;
            },
        },
        methods: {
            getPeriodWonClass(period, teamIndex, periodIndex) {
                // In football we bold only last period
                if (this.sportId === SportId.Football && periodIndex !== this.liveData.score.length - 1) {
                    return '';
                }
                if (period[teamIndex] > period[1 - teamIndex]) {
                    return 'live-score-widget__score-number--won';
                }
            },
            getTennisPointsClass(periodIndex) {
                if (
                    this.sportId === SportId.Tennis
                    && periodIndex === 0
                    && !this.isMatchFinished
                ) {
                    return 'live-score-widget__score-number--points';
                } else {
                    return '';
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~@superbet-group/web.lib.global-styles/type';
    @import '~@superbet-group/web.lib.global-styles/responsive';

    .live-score-widget {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        gap: 4px;

        &:not(&--flex-end) {
            @include respond-to-above(dXs, true) {
                justify-content: flex-start;
            }
        }

        &__periods-container {
            display: flex;
            align-items: center;
            height: 16px;
        }

        &__periods {
            display: flex;
        }

        &__period {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 26px;
            height: 14px;
            @include font-11-regular;
            line-height: 14px;
            color: var(--system-text-on-elevation-tertiary);
        }

        &__score {
            display: flex;

            &-column {
                display: flex;
                flex-direction: column;
                width: 26px;
            }

            &-number {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 24px;
                @include font-14-regular;
                line-height: 18px;
                color: var(--system-text-on-elevation-tertiary);

                &--won {
                    font-weight: $font-weight-medium;
                    color: var(--system-text-on-elevation-primary);
                }

                &--points {
                    color: var(--system-text-on-elevation-success-primary);
                }
            }
        }
    }
</style>
